module.exports = __webpack_public_path__ + "media/images/edools_logo-lg-52756acfb814de042d9fcdc9648babde.png";